import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNumberFormatDirective]'
})
export class NumberFormatDirectiveDirective {

  constructor(private el: ElementRef) {}
  @HostListener('input', ['$event']) onInput(event: any): void {
    const input = event.target;
    const value = input.value.replace(/\D/g, ''); // Remove non-numeric characters
    input.value = this.formatNumber(value); // Format the number with Indian numbering
  }
  private formatNumber(value: string): string {
    // console.log(value);
    value = value.toString();
    var lastThree = value.substring(value.length-3);
    var otherNumbers = value.substring(0,value.length-3);
    if(otherNumbers != '')
        lastThree = ',' + lastThree;
    var parts = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    // console.log(parts);
    return parts;
      // const parts = value.split('.');
      // parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas (lakh separator)
      // return parts.join('.');
  }}
